<template>
	<div class="window-stack">
		<transition-group name="window-stack__window-trans window-stack__window-trans-" tag="div" style="height: 100%;">
			<component 
				:class="'window-stack__window window-stack__window--' + (window.comp.pos ? window.pos : 'default') + (index < windows.length - 1 ? ' window-stack__window--hidden' : '') + (index > 0 ? ' window-stack__window--prev' : '') + (minimized ? ' minimized' : '')" 
				v-for="(window, index) in windows" 
				:key="index" 
				:is="window.comp" 
				:hmm="index"
				@click.native="click"
				@push="push" 
				@pop="pop" 
				@replace="replace" 
				@close="close"
			
				v-bind="window.props" />
		</transition-group>
	</div>
</template>

<script>
	import { bus } from '../bus'

	export default {
		data() {
			return {
				minimized: false,
				windows: []
			};
		},
		methods: {
			open(window, props = {}) {
				this.windows = [{
					comp: window,
					props: props
				}];
			},
			push(window, props = {}) {
				this.windows.push({
					comp: window,
					props: props
				});
			},
			pop() {
				if (this.windows.length > 0) {
					this.windows.pop();
				}
			},
			replace(window, props ={}) {
				if (this.windows.length > 0) {
					this.windows.splice(this.windows.length - 1, 1, {
					comp: window,
					props: props
				});
				}
			},
			close() {
				if (this.windows.length > 1 && !confirm('Vil du lukke ' + this.windows.length + ' vinduer?')) {
					return false;
				}

				if (this.windows.length > 0) {
					this.windows = [];
				}
			},
			click() {
				console.log('clik!!!');

				if (this.minimized) {
					this.minimized = false;
				}
			}
		},
		created() {
			var self = this;

			bus.$on('minimize', function () {
				console.log('minimize');
				self.minimized = true;
				
			});
		}
	}
</script>

<style lang="scss">
	.window-stack {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;

		&__window {
			position: absolute;
			pointer-events: all;

			transition: all 250ms;
		
			&--right, &--default {
				top: 0;
				right: 0;
				bottom: 0;
				width: 600px;
			}

			&--hidden {
				opacity: 0;
			}

			&.minimized {
				transform:         translate3d(550px, 0, 0);
				opacity: 0.2;
				cursor: pointer;

				&:hover {
					opacity: 0.6;
				}
			}
		}

		&__window-trans {
			&--enter, &--leave-to {
				opacity: 0;
				visibility: hidden;
				transform:         translate3d(200px, 0, 0);
			}

			&--enter-to {
				opacity: 1;
				visibility: visible;
				transform:         translate3d(0, 0, 0);
			}
		}
	}
</style>